import pagination from './index.vue';

export default pagination;
